module.exports = __webpack_public_path__ + "static/media/Bluelab Sample Tube and Fittings.1bfb6222.webp";